import React, {Component} from "react";
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {getCash, getInfo, logOut} from "../redux/actions/user";
import Loading from "./Loading";
import {LOCAL} from "../constants/local";

class UserProfile extends Component {
	logout(e) {
		e.preventDefault();
		this.props.onLogout();
	}

	render() {
		const {user} = this.props;
		const userinfo = user.info;
		const {cash} = user;

		if ( user.login.auth ) {
			return (
				<div className="userprofile">
					{user.fetching && <Loading/>}

					<ul className="userprofile__items">
						<li className="userprofile__items__item profile">
							<Link to={'/user/history'}>
								<i className="fas fa-user"/>
							</Link>
							<ul>
								<li>
									<div className="user_name">{userinfo.first_name}</div>
									<div className="user_number">№ счёта: {userinfo.id}</div>
								</li>
								<li>
									<div className="logout">
										<Link to={''} onClick={this.logout.bind(this)}>Выход</Link>
									</div>
								</li>
							</ul>
						</li>
						<li className="userprofile__items__item cash">
							<Link to={'/user/payments'}>
								<div className="money">{cash.money}&nbsp;{LOCAL.currency}</div>
								<div className="in-game">{cash.in_game}&nbsp;{LOCAL.currency}</div>
							</Link>
						</li>
						<li className="userprofile__items__item pay">
							<Link to={'/user/pay'}>
								Пополнить счет
							</Link>
						</li>
					</ul>
				</div>
			);
		}

		return (
			<div className="userprofile">
				<ul className="userprofile__items">
					<li className="userprofile__items__item" style={{border : '0'}}>
						<Link to={'/auth'}>
							<i className="fas fa-key"/>
						</Link>
					</li>
					<li className="userprofile__items__item pay">
						<Link to={'/user/signup'}>Регистрация</Link>
					</li>
				</ul>
				{/*<div className="userprofile__logout buttons">*/}
				{/*<Link to={'/user/signup'} className="buttons__show">Регистрация</Link>*/}
				{/*<Link to={'/auth'} className="buttons__show">Войти</Link>*/}
				{/*</div>*/}
			</div>);
	}
}

export default connect(
	state => ({
		bet  : state.bet,
		user : state.user,
	}),
	dispatch => ({
		onLogout : () => {
			dispatch(logOut());
		},
	})
)(UserProfile);


// WEBPACK FOOTER //
// ./src/app/components/UserProfile.js